/*
 *   Copyright (c) 2020
 *   All rights reserved.
 *   Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.  2020 WARNING: this file may contain export controlled information.
 */
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
  2020 WARNING: this file may contain export controlled information.*/
import * as AWS from 'aws-sdk/global';
import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Store } from '@ngrx/store';
import { Observable, from, Subscription, of } from 'rxjs';
import { LocalStorageService } from './local-storage.service';
import { switchMap, catchError } from 'rxjs/operators';
import { signIn, signOut, getCurrentUser, fetchAuthSession, signUp, confirmSignUp, resetPassword, confirmResetPassword } from 'aws-amplify/auth';
import { Actions } from '@ngrx/effects';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { UserPageActions } from '../../shared/store/actions/userActions/index';
import { SignUpFormValidationService } from '../services/signUpFormValidationService.service';
const shajs = require('sha.js');
const AmazonCognitoIdentity = require('amazon-cognito-identity-js');
import jwt_decode from 'jwt-decode';

import { CognitoUserPool, AuthenticationDetails, CognitoUser, CognitoUserAttribute } from 'amazon-cognito-identity-js';
import { AppUserActions } from '../store/app-user.reducer';
import { IState } from '../store/root.store';
import { AppSessionUser } from '../domain/app-session-user.entity';

const authenticationData: { Username: string; Password: string } = {
  Username: '',
  Password: '',
};
const smsMfaSettings = {
  PreferredMfa: true,
  Enabled: true,
};
const totpMfaSettings = {
  PreferredMfa: true,
  Enabled: true,
};
let authenticationDetails;

const poolData = {
  UserPoolId: environment.userPoolId,
  ClientId: environment.clientId,
};

let userPool;

let userData;
let refresh_token;

let cognitoUser;

//end of vars

@Injectable({ providedIn: 'root' })
export default class CognitoService {
  mfaSubscription: Subscription;

  poolData = {
    UserPoolId: environment.userPoolId,
    ClientId: environment.clientId,
  };
  userPool = new CognitoUserPool(poolData);

  constructor(
    private store: Store<IState>,
    @Inject(LOCAL_STORAGE) private storage: StorageService,
    private localStore: LocalStorageService,
    private $actions: Actions<UserPageActions.Actions>,
    private localSignUpFormValidationService: SignUpFormValidationService
  ) {
    AWS.config.update({
      region: environment.region,
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.userPoolId,
      }),
    });
    AWS.config.region = environment.region;
    AWS.config.update({ accessKeyId: 'null', secretAccessKey: 'null' });
  }

  signOutOfAllPreviousSessions(user, password) {
    return new Promise(async (resolve, reject) => {
      const authenticationData = {
        Username: user,
        Password: password,
      };
      authenticationDetails = new AuthenticationDetails(authenticationData);
      const poolData = {
        UserPoolId: environment.userPoolId, // Your user pool id here
        ClientId: environment.clientId, // Your client id here
      };
      userPool = new CognitoUserPool(poolData);
      userData = {
        Username: user,
        Pool: userPool,
      };
      cognitoUser = new CognitoUser(userData);
      try {
        cognitoUser.globalSignOut({ onSuccess: resolve('signed-out') }, { onFailure: reject() });
      } catch (err) {
        reject();
      }
    });
  }

  cognitoLoginSystem(user, password) {
    const context = this;
    return new Promise(async (resolve, reject) => {
      const signOutResult = await this.signOutOfAllPreviousSessions(user, password);
      const authenticationData = {
        Username: user,
        Password: password,
      };
      authenticationDetails = new AuthenticationDetails(authenticationData);
      const poolData = {
        UserPoolId: environment.userPoolId, // Your user pool id here
        ClientId: environment.clientId, // Your client id here
      };
      userPool = new CognitoUserPool(poolData);
      userData = {
        Username: user,
        Pool: userPool,
      };
      cognitoUser = new CognitoUser(userData);

      // set txt as default
      // cognitoUser.setUserMfaPreference(smsMfaSettings, null, function(err, result) {
      //     if (err) {
      //         alert(err.message || JSON.stringify(err));
      //     }
      //     console.log('call result ' + result);
      // });

      // set time based as default
      // cognitoUser.setUserMfaPreference(null, totpMfaSettings, function(err, result) {
      //     if (err) {
      //         alert(err.message || JSON.stringify(err));
      //     }
      //     console.log('call result ' + result);
      // });

      // let authenticatedCognitoUser = await cognitoUser.authenticateUser(authenticationDetails, {
      //     onSuccess: (result) => {
      //         console.log("resulted already", result)
      //         resolve({type:"success", data: result})
      //         let cognitoGetUser = userPool.getCurrentUser();
      //         if (cognitoGetUser != null) {
      //         cognitoGetUser.getSession(function(err, result) {
      //             if (result) {
      //             // console.log ("Authenticated to Cognito User Pools!");
      //             }
      //         });
      //         }
      //     },
      //     onFailure: (err) => {
      //         console.log("the error234", err)
      //         reject({type:"failre", data:err})
      //     }
      // })
      // console.log("authed", authenticatedCognitoUser)

      // var smsMfaSettings = {
      //     PreferredMfa: true,
      //     Enabled: true,
      // };
      // cognitoUser.setUserMfaPreference(smsMfaSettings, null, function(err, result) {
      //     if (err) {
      //         console.log("bad error", err)
      //         alert(err.message || JSON.stringify(err));
      //     }
      //     console.log('call result ' + result);
      // });

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          resolve({ type: 'success', data: result });
          const cognitoGetUser = userPool.getCurrentUser();
          if (cognitoGetUser != null) {
            cognitoGetUser.getSession(function (err, result) {
              if (result) {
                // console.log ("Authenticated to Cognito User Pools!");
              }
            });
          }
        },
        onFailure: (err) => {
          // console.log("the error", err)
          reject({ type: 'failre', data: err });
        },
        selectMFAType(challengeName, challengeParameters) {
          let mfaType = prompt('Please select the MFA method.', ''); // valid values for mfaType is "SMS_MFA", "SOFTWARE_TOKEN_MFA"
          mfaType = 'SMS_MFA';
          cognitoUser.sendMFASelectionAnswer(mfaType, this);
        },
        mfaSetup(challengeName, challengeParameters) {
          const mfaType = 'SMS_MFA';
          cognitoUser.sendMFASelectionAnswer(mfaType, this);
          const smsMfaSettings = {
            PreferredMfa: true,
            Enabled: true,
          };
          // cognitoUser.setUserMfaPreference(smsMfaSettings, null, function(err, result) {
          //     if (err) {
          //         console.log("there was an error", err)
          //         alert(err.message || JSON.stringify(err));
          //     }
          //     console.log('call result ' + result);
          // });
        },
        async mfaRequired(codeDeliveryDetails) {
          const awaitMfa = await context.dispatchMfaCodeDialog();
          const subCongitoContext = this;
          context
            .subscribeToMfaCode()
            .then(async (code) => {
              cognitoUser.sendMFACode(code, subCongitoContext);
              context.unsubscribeToMfaCode();
              context.dispatchMfaDone();
            })
            .catch((err) => {
              context.unsubscribeToMfaCode();
              context.dispatchMfaFail();
            });
        },
        newPasswordRequired: (data, data2) => {
          const cognitoGetUser = userPool.getCurrentUser();
          if (cognitoGetUser != null) {
            cognitoGetUser.getSession(function (err, result) {
              if (result) {
                // console.log ("Authenticated to Cognito User Pools!", result);
              }
            });
          }

          this.newPasswordRequired(data, data2).then((resultPass) => {
            resolve({ type: 'newPassword', data: resultPass });
          });
        },
      });
    });
  }

  amplifyLogin = () => {
    signIn({ username: authenticationData.Username, password: authenticationData.Password })
      .then((success) => console.log('successful sign in', success))
      .catch((err) => console.log(err));
  };

  dispatchMfaCodeDialog = async () => {
    this.store.dispatch({
      type: UserPageActions.START_MFA,
      payload: {
        username: authenticationData.Username,
      },
    });
  };

  subscribeToMfaCode = async () =>
    new Promise((resolve, reject) => {
      this.mfaSubscription = this.$actions.subscribe((data) => {
        resolve(data.payload);
      });
    });

  dispatchMfaDone = async () => {
    this.store.dispatch({
      type: UserPageActions.MFA_COMPLETE,
    });
  };

  dispatchMfaFail = async () => {
    this.store.dispatch({
      type: UserPageActions.MFA_FAIL,
    });
  };

  unsubscribeToMfaCode = async () => {
    this.mfaSubscription.unsubscribe();
  };

  globalSignOut = () => {
    this.storage.clear();
    return new Promise((resolve, reject) => {
      if (cognitoUser) {
        cognitoUser.globalSignOut({ onSuccess: resolve(true) });
      }
      resolve(true);
    });
  };

  createAccount = (username, password, attributeList) =>
    new Promise((resolve, reject) => {
      const cognitoAttributeList: CognitoUserAttribute[] = [];
      const attributeEmail = new CognitoUserAttribute(
        attributeList.dataEmail
      );
      const attributeFamilyName = new CognitoUserAttribute(
        attributeList.dataFamilyName
      );
      const attributeName = new CognitoUserAttribute(attributeList.dataName);
      const unitName = new CognitoUserAttribute({
        Name: attributeList.dataUnit.Name,
        Value: attributeList.dataUnit.Value.unitsuuid,
      });
      const majcom = new CognitoUserAttribute({
        Name: attributeList.majcom.Name,
        Value: attributeList.majcom.value,
      });
      const base = new CognitoUserAttribute({
        Name: attributeList.base.Name,
        Value: attributeList.base.value.bases,
      });
      // let phoneNumber = new AmazonCognitoIdentity.CognitoUserAttribute({
      //     Name: attributeList.dataPhoneNumber.Name,
      //     Value: attributeList.dataPhoneNumber.Value
      // });
      cognitoAttributeList.push(attributeEmail);
      cognitoAttributeList.push(attributeFamilyName);
      cognitoAttributeList.push(attributeName);
      cognitoAttributeList.push(unitName);
      cognitoAttributeList.push(majcom);
      cognitoAttributeList.push(base);
      // cognitoAttributeList.push(phoneNumber)

      const createAccoutUserPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      //Here we need to call the hash api before creating the actual account

      this.localSignUpFormValidationService
        .storeHash({
          passwordHash: shajs('sha256').update(password).digest('hex'),
          cognitoSub: username.toLowerCase(),
        })
        .then((data) => {
          createAccoutUserPool.signUp(
            username,
            password,
            cognitoAttributeList,
            null,
            function (err, result) {
              if (err) {
                alert(err.message || JSON.stringify(err));
                reject(err);
              }
              const cognitoUserName = result.user.username;
              resolve(cognitoUserName);
            }
          );
        })
        .catch((err) => { });
    });

  initVariables = async (username, password) =>
    new Promise((resolve, reject) => {
      authenticationData.Username = username;
      authenticationData.Password = password;

      this.localSignUpFormValidationService.checkDisabled({ username }).then((data) => {
        if (data) {
          // if(data.response)
          authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
            authenticationData
          );

          userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

          userData = {
            Username: authenticationData.Username,
            Pool: userPool,
          };

          cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);

          cognitoUser.signOut();

          if (typeof localStorage !== 'undefined') {
            Object.keys(localStorage).forEach(key => {
              if (key.includes('cognito') || key.includes('CognitoIdentityServiceProvider')) {
                localStorage.removeItem(key);
              }
            });
          }

          this.cognitoLoginSystem(authenticationData.Username, authenticationData.Password)
            .then((data) => {
              resolve(data);
            })
            .catch((err) => {
              //Decide what to do based on the error here
              if (err.data.message == 'PreAuthentication failed with error newPasswordRequired.') {
                //New password required....
              }
              reject(err);
            });
        } else {
          //Bad! Show bad message
          this.store.dispatch({
            type: UserPageActions.SEND_GLOBAL_MESSAGE,
            payload: {
              message: 'Please contact cbmhelp@pavconllc.com to re-activate your account',
            },
          });
          const errormessage = {
            message: 'Please contact support to re-activate your account',
          };
          reject(errormessage);
        }
      });
    }).catch((err) => { });

  initVariablesUsernameOnly = async (username) =>
    new Promise((resolve, reject) => {
      authenticationData.Username = username;

      authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);

      userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      userData = {
        Username: authenticationData.Username,
        Pool: userPool,
      };

      cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      resolve({});
    });

  resolveLogin = (result) =>
    new Promise((resolve, reject) => {
      if (typeof result === 'undefined') {
        const data = {
          message: 'Incorrect username or password',
          code: 'error',
        };
        reject(data);
          } else {
            const decodedToken = jwt_decode(result.data.idToken.jwtToken) as AppSessionUser;
            const currentState = this.store.select(state => state.appUser?.sessionUser);
            currentState.subscribe(currentUser => {
              if (!currentUser || currentUser.sub !== decodedToken.sub) {
                this.store.dispatch({
                  type: AppUserActions.SET_SESSION_USER,
                  payload: decodedToken,
                });
              }
            }).unsubscribe();
            resolve(result.data);
          }
    });

  callLogin = (username, password): Observable<any> =>
    from(this.initVariables(username, password)).pipe(
      switchMap((result) => {
        if (typeof result === undefined) {
          throw new Error('Login error');
        } else {
          return this.resolveLogin(result);
        }
      }),
      catchError(this.handleLoginError)
    );

  handleLoginError(err) {
    console.log('erorr:', err);
    return of(err);
  }

  onSuccess = (result) => {
    const accessToken = result.getAccessToken().getJwtToken();
    //Store.dispatch(new UserActions.Add_USER({idToken: result.getIdToken().getJwtToken()}) )
    //POTENTIAL: Region needs to be set if not already set previously elsewhere.
    AWS.config.region = environment.region;

    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: '...', // your identity pool id here
      Logins: {
        // Change the key below according to the specific region your user pool is in.
        'cognito-idp.us-gov-west-1.amazonaws.com/us-gov-west-1_ctdZGh3tX': result
          .getIdToken()
          .getJwtToken(),
      },
    });
    return 'hello';
  };

  onFailure = (err) => {
    // console.log("On failure")
    // console.log(err)
    // alert(err.message || JSON.stringify(err));
  };

  newPasswordRequired = (sessionUserAttributes, requiredAttributes) =>
    new Promise((resolve, reject) => {
      cognitoUser.getSession(function (err, session) { });
      sessionUserAttributes.family_name = 'newFamilyName';
      delete sessionUserAttributes.email_verified;
      sessionUserAttributes.name = 'newName';
      cognitoUser.completeNewPasswordChallenge('Supertemppassword2!', sessionUserAttributes, {
        onSuccess: (result) => {
          resolve(result);
        },
        onFailure: (err) => {
          reject();
          throw err;
        },
      });
    });

  handleNewPassword(newPassword, sessionUserAttributes) {
    cognitoUser.completeNewPasswordChallenge(newPassword, sessionUserAttributes);
  }

  confirmPassword = (username, verificationCode, newPassword) => {
    cognitoUser = new AmazonCognitoIdentity.CognitoUser({
      Username: username,
      Pool: userPool,
    });

    return new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onFailure(err) {
          reject(err);
        },
        onSuccess() {
          resolve({});
        },
      });
    });
  };

  login = async () =>
    new Promise(async (resolve, reject) => {
      const result = await cognitoUser.authenticateUser(authenticationDetails, {
        newPasswordRequired: resolve('newPasswordRequired'),
        onSuccess: resolve('authSuccess'),
        onFailure: resolve('authFailed'),
      });
    });

  confirmRegistration = (confirmationCode) =>
    new Promise((resolve, reject) => {
      const cognitoUserRegistration = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
        if (err) {
          // alert(err.message || JSON.stringify(err));
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

  resendCode = () =>
    new Promise((resolve, reject) => {
      cognitoUser.resendConfirmationCode(function (err, result) {
        if (err) {
          alert(err.message || JSON.stringify(err));
          reject(err);
        } else {
          resolve(result);
        }
      });
    });

  resendCodeForgotPassword = (username) =>
    new Promise((resolve, reject) => {
      const forgotPoolData = {
        UserPoolId: environment.userPoolId, // Your user pool id here
        ClientId: environment.clientId, // Your client id here
      };

      userPool = new CognitoUserPool(forgotPoolData);
      const localUserData = {
        Username: username,
        Pool: userPool,
      };

      cognitoUser = new CognitoUser(localUserData);
      cognitoUser.forgotPassword({
        onSuccess(data) {
          // successfully initiated reset password request
          resolve(data);
        },
        onFailure(err) {
          alert(err.message || JSON.stringify(err));
          reject(err);
        },
      });
    });

  forgotPassword = (username, password) =>
    new Promise((resolve, reject) => {
      const forgotPoolData = {
        UserPoolId: environment.userPoolId, // Your user pool id here
        ClientId: environment.clientId, // Your client id here
      };

      userPool = new CognitoUserPool(forgotPoolData);
      const localUserData = {
        Username: username,
        Pool: userPool,
      };

      cognitoUser = new CognitoUser(localUserData);
      this.localSignUpFormValidationService
        .storeHash({
          passwordHash: shajs('sha256').update(password).digest('hex'),
          cognitoSub: username.toLowerCase().trim(),
        })
        .then((data) => {
          cognitoUser.forgotPassword({
            onSuccess(data) {
              // successfully initiated reset password request
              resolve(data);
            },
            onFailure(err) {
              alert(err.message || JSON.stringify(err));
              reject(err);
            },
          });
        })
        .catch((err) => {
          reject(err);
        });
    });

  getTokenFromLocalStore = () => {
    const lastKnownUser = this.storage.get(
      (
        'CognitoIdentityServiceProvider.' +
        environment.clientId.toString() +
        '.LastAuthUser'
      ).toString()
    );
    return this.storage.get(
      'CognitoIdentityServiceProvider.' + environment.clientId + '.' + lastKnownUser + '.idToken'
    );
  };

  getCurrentUser = () => {
    // debugger;
    //if(!this.userPool) {
    this.userPool = new CognitoUserPool(this.poolData);
    //}
    const user = this.userPool.getCurrentUser();
    // console.debug(user);
    return user;
  };

  getCurrentIdToken = () =>
    new Promise((resolve, reject) => {
      const poolData = {
        UserPoolId: environment.userPoolId, // Your user pool id here
        ClientId: environment.clientId, // Your client id here
      };
      const userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);
      const cognitoUser = userPool.getCurrentUser();

      if (cognitoUser != null) {
        cognitoUser.getSession(function (err, session) {
          if (err) {
            alert(err.message || JSON.stringify(err));
            reject(err);
            // return;
          }
          if (session.isValid()) {
            resolve(session.idToken.jwtToken);
          } else {
            refresh_token = session.getRefreshToken();
            if ((AWS.config.credentials as AWS.Credentials).needsRefresh()) {
              cognitoUser.refreshSession(refresh_token, (err, session) => {
                if (err) {
                  reject(err);
                } else {
                  const test = AWS.config.credentials as any;
                  test.params.Logins[
                    'cognito-idp.' + environment.region + '.amazonaws.com/' + environment.userPoolId
                  ] = session.getIdToken().getJwtToken();
                  (AWS.config.credentials as AWS.Credentials).refresh((err) => {
                    if (err) {
                      // console.log(err);
                      reject(err);
                    } else {
                      resolve(session.getIdToken().getJwtToken());
                    }
                  });
                }
              });
            }
          }
        });
      }
    });

  finishForgotPassword = (verificationCode, newPassword, username) =>
    new Promise((resolve, reject) => {
      cognitoUser.confirmPassword(verificationCode, newPassword, {
        onSuccess() {
          resolve('password changed');
        },
        onFailure(err) {
          // console.log('Password not confirmed!', err);
          reject(err);
        },
      });
    });
}
/*Distribution Statement B. Distribution authorized to U.S. Government agencies only.PavCon, LLC Proprietary.All rights reserved.
  2020 WARNING: this file may contain export controlled information.*/
